export const blockIconsCommunicationMarkEmailUnreadNew = (
	<span className='material-symbols-outlined'>mark_email_unread</span>
);
